<template>
  <el-dialog
    :visible.sync="resetDialog"
    :lock-scroll="false"
    :close-on-click-modal="true"
    :before-close="close"
    title="重置密码"
    width="430px"
    custom-class="reset"
  >
  <div class="resetBox">
    <form method="post">
      <div class="login_user login_phone">
        <input
          class="user"
          type="text"
          v-model="phone"
          placeholder="请输入手机号"
          @keydown.enter="doPost"
          ref="phone"
        />
      </div>
      <div class="login_user login_code">
        <input
          class="code"
          type="text"
          v-model="smscode"
          placeholder="请输入短信验证码"
          @keydown.enter="doPost"
          ref="smscode"
        />
        <a href="javascript:;" class="getCode" @click="getSMSCode">{{
          sendText
          }}</a>
      </div>
      <div class="login_user login_pwd">
        <input
          class="pwd"
          type="password"
          v-model="password1"
          placeholder="请输入密码"
          @keydown.enter="doPost"
          ref="password"
        />
      </div>
      <div class="login_user login_pwd">
        <input
          class="pwd"
          type="password"
          v-model="password2"
          placeholder="请输入密码"
          @keydown.enter="doPost"
          ref="password"
        />
      </div>
      <a href="javascript:;" @click="doPost()" class="login_btn">重置</a>

    </form>
  </div>
  </el-dialog>
</template>

<script>
    export default {
        name: "ResetPwd",
      props: {
        resetDialog: Boolean,
      },
      data(){
          return{
            phone:'',
            smscode:'',
            password1:'',
            password2:'',
            sendText:'获取验证码',
            isSend: true,
            totalTime: 10,
          }
      },
      methods:{
        getSMSCode(){
          if(this.isSend){
            this.isSend = false
            var timer = setInterval(()=>{
              this.totalTime --
              this.sendText=this.totalTime + 's后重新获取'
              if(this.totalTime <= 0){
                this.sendText = "重新获取"
                this.isSend = true
                this.totalTime = 10
                clearInterval(timer)
              }
            },1000)
          }
        },
        close() {
          this.$parent.resetClose();
        },
      }
    }
</script>

<style scoped lang="less">
/deep/ .reset{
  border-radius: 6px;
  .el-dialog__header{
    border: none!important;
    text-align: center;
    line-height: 48px;
    height: 48px;
    font-size: 18px;
    color: #434343;
  }
  .resetBox{
    width: 320px;
    margin: 0 auto;
    padding-top: 0;
  }

  .resetBox .login_user {
    margin-bottom: 20px;
    position: relative;
    border: 1px solid #e5e5e5;

    &:before {
      content: "";
      width: 40px;
      height: 39px;
      position: absolute;
      left: 0;
      top: 0;
      background: transparent url(../assets/images/dl_xtb_yhm.png) 10px center no-repeat;
    }
  }

  .resetBox .login_pwd {
    margin-bottom: 20px;
  }

  .resetBox .login_phone:before {
    background: url(../assets/images/dl_xtb_yhm.png) 10px center no-repeat;
  }

  .resetBox .login_pwd:before {
    background: url(../assets/images/dl_xtb_mm.png) 10px center no-repeat;
  }

  .resetBox .login_img:before {
    /*padding-right: 130px;*/
    background: url(../assets/images/dl_xtb_yzm.png) 10px center no-repeat;
  }

  .resetBox .login_code:before {
    /*padding-right: 130px;*/
    background: url(../assets/images/dl_xtb_dx.png) 10px center no-repeat;
  }

  .resetBox .login_user input {
    width: 100%;
    height: 39px;
    line-height: 33px;
    font-size: 14px;
    color: #818181;

    padding: 0 8px 0 40px;
    box-sizing: border-box;
  }

  /* WebKit browsers 适配谷歌 */
  .resetBox .login_user input::-webkit-input-placeholder {
    color: #c8cdd4;
  }

  /* Mozilla Firefox 4 to 18 适配火狐 */
  .resetBox .login_user input:-moz-placeholder {
    color: #c8cdd4;
  }

  /* Mozilla Firefox 19+ 适配火狐 */
  .resetBox .login_user input::-moz-placeholder {
    color: #c8cdd4;
  }

  /* Internet Explorer 10+  适配ie*/
  .resetBox .login_user input:-ms-input-placeholder {
    color: #c8cdd4;
  }

  .resetBox .login_img {
    position: relative;
  }

  .resetBox .login_user img {
    width: 88px;
    height: 30px;
    position: absolute;
    right: 4.5px;
    top: 4.5px;
  }

  .resetBox .login_code {
    position: relative;
  }

  .resetBox .login_user .getCode {
    display: inline-block;
    min-width: 88px;
    text-align: center;
    height: 27px;
    color: #4cba0e;
    position: absolute;
    right: 8px;
    top: 6px;
    font-size: 14px;
    border-left: 1px solid #e7e7e7;
    line-height: 27px;
    padding-left: 8px;
    box-sizing: border-box;
  }

  .login_btn {
    display: block;
    width: 100%;
    height: 45px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    line-height: 45px;
    background: #4cba0e;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    overflow: hidden;
    margin-top: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ResetPwd.vue